import { useState } from "react";
import { format, isValid, parse } from "date-fns";
import { signal } from "@preact/signals-react";
import { es } from "date-fns/locale";

import Calendar from "componentsv2/widgets/Calendar";
import { Calendar2Icon, TrashIcon } from "components/Icons";
import FormField from "./FormField";
import upStore from "store/upStore";

const FMT_JS = "dd/MM/yyyy";
const FMT_TYRON = "yyyy-MM-dd";
const regex = /^[0-9\/]+$/;

function DateInputField(props) {
  const { field, data, attrs } = props;
  const { name, readOnly, label, required } = field;
  const [month, setMonth] = useState("");
  const { level, minDate = false, maxDate = false } = attrs;
  const showPop = signal(false);

  function handlePop() {
    showPop.value = true;
  }
  function handleRemove() {
    data.value = "";
  }

  function onChange(event) {
    const value = event.target.value;
    if (value.length > 10 || (value !== "" && !regex.test(value))) {
      return;
    }
    data.value = value;
  }

  function handleBlur(event) {
    const value = event.target.value;
    const parsedDate = parse(value, FMT_JS, new Date());
    if (isValid(parsedDate)) {
      setMonth(parsedDate);
      update(parsedDate);
    } else {
      data.value = "";
    }
  }

  function update(value) {
    upStore(level, {
      fieldName: name,
      value: format(value, FMT_TYRON), // For store to Tryton
      valueActive: value, // For record active
      field: field,
    });
    if (field.onChange) {
      field.onChange(field.name, value);
    }
  }

  function handleDatePop(value) {
    if (value.length === 0) return;
    data.value = value;
    update(value);
  }

  let _value = data.value || "";
  if (data.value && typeof data.value.getMonth === "function") {
    _value = format(data.value, FMT_JS, { locale: es });
  }
  return (
    <FormField label={label} name={name} required={required}>
      <div className="grid">
        <div className="h-10 border border-neutral-200 bg-white flex p-2 rounded-lg w-full">
          <input
            type="text"
            value={_value}
            onChange={onChange}
            onBlur={handleBlur}
            disabled={readOnly}
            className="focus:outline-none w-full"
            placeholder="dd/MM/yyyy"
          />
          <button
            type="button"
            className="cursor-pointer"
            onClick={!_value ? handlePop : handleRemove}
          >
            {!_value ? (
              <Calendar2Icon className="text-white h-6 w-6 fill-current my-auto" />
            ) : (
              <TrashIcon className="size-5.5 text-neutral-500 active:text-sky-600 cursor-pointer active:scale-90 fill-current" />
            )}
          </button>
        </div>
        <Calendar
          mode="single"
          month={month}
          selected={data}
          onSelect={handleDatePop}
          show={showPop}
          initialFocus
        />
      </div>
    </FormField>
  );
}

export default DateInputField;
